import superballs from '../elements/superballs.js';
superballs.register();
